import React from 'react';
import LoadingSequence from 'assets/Loading/LoadingSequence';
import WidgetDiagnostics from './WidgetDiagnostics';
import { useWidgetFetch } from 'hooks/useWidgetFetch';
import { apiPath } from 'apiurl';

const METADATA_URL = `${apiPath}/api/dashboard-status/metadata-counts`;
const PLAT_COLORS = ['#4f46e5','#0d9488','#ea580c','#7c3aed','#0369a1','#b45309'];

function GenomicSignals() {
  const { data, loading, timing } = useWidgetFetch(METADATA_URL, {
    ttl: 10 * 60 * 1000,
    swr: 30 * 60 * 1000,
    widgetId: 'Genomic Signals',
  });

  const platforms        = data?.platforms        ?? [];
  const isolationSources = data?.isolationSources ?? [];
  const uniqueCounts     = data?.uniqueCounts     ?? {};

  return (
    <div className="dash-insight-card">
      <div className="insight-header">
        <span className="insight-dot insight-purple" />
        <span className="insight-title">Genomic Signals</span>
        <WidgetDiagnostics timing={timing} url={METADATA_URL} />
      </div>
      {loading ? (
        <LoadingSequence message="Loading" size="small" />
      ) : (
        <div className="sig-grid">
          <div className="sig-col">
            <div className="sig-col-head">
              <i className="bi bi-cpu-fill" />
              Platform
              <span className="sig-badge">{uniqueCounts.platforms || platforms.length}</span>
            </div>
            {platforms.length === 0 ? (
              <div className="insight-empty">No data</div>
            ) : (
              platforms.slice(0, 7).map((item, i) => (
                <div key={i} className="sig-row" style={{ '--accent': PLAT_COLORS[i % PLAT_COLORS.length] }}>
                  <span className="sig-accent-bar" />
                  <span className="sig-name" title={item.label}>{item.label}</span>
                  <span className="sig-val">{item.count.toLocaleString()}</span>
                </div>
              ))
            )}
          </div>

          <div className="sig-col sig-col--right">
            <div className="sig-col-head">
              <i className="bi bi-droplet-fill" />
              Isolation Source
              <span className="sig-badge">{uniqueCounts.isolationSources || isolationSources.length}</span>
            </div>
            {isolationSources.length === 0 ? (
              <div className="insight-empty">No data</div>
            ) : (
              isolationSources.slice(0, 8).map((item, i) => (
                <div key={i} className="sig-row sig-row--iso">
                  <span className="sig-rank">{i + 1}</span>
                  <span className="sig-name" title={item.label}>{item.label}</span>
                  <span className="sig-val">{item.count.toLocaleString()}</span>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default GenomicSignals;
